import React from 'react';
import { motion } from 'framer-motion';
import { Instagram, Film, Users, Sparkles } from 'lucide-react';

const services = [
  {
    icon: Instagram,
    title: 'Instagram Growth System',
    description: 'A complete system that turns your Instagram into a customer acquisition channel. Strategy, execution, and optimization — all handled.',
    span: 'md:col-span-8',
    accent: true,
  },
  {
    icon: Film,
    title: 'Content & Reels Strategy',
    description: 'Scroll-stopping Reels and content that actually reaches your target audience. We plan, script, and guide every piece.',
    span: 'md:col-span-4',
  },
  {
    icon: Users,
    title: 'Influencer Marketing',
    description: 'Strategic collaborations with local Instagram influencers who bring real foot traffic to your business.',
    span: 'md:col-span-4',
  },
  {
    icon: Sparkles,
    title: 'Profile Optimization',
    description: 'Your bio, highlights, and profile become a conversion machine. Every visitor knows exactly what you offer and how to buy.',
    span: 'md:col-span-8',
  },
];

export const ServicesSection = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <span className="font-accent text-slate-400 mb-4 block" data-testid="services-label">
            What We Do
          </span>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-slate-900 leading-tight max-w-2xl"
            data-testid="services-headline"
            style={{ fontFamily: 'Outfit, sans-serif' }}
          >
            Everything You Need to{' '}
            <span className="font-medium">Win on Instagram</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-6">
          {services.map((service, i) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`col-span-1 ${service.span} bg-slate-50 border border-slate-100 rounded-3xl p-8 md:p-10 hover:border-slate-200 transition-colors group`}
              data-testid={`service-card-${i}`}
            >
              <div className="flex items-start gap-4">
                <div className={`p-3 rounded-2xl ${service.accent ? 'bg-slate-900 text-white' : 'bg-white text-slate-700 border border-slate-200'}`}>
                  <service.icon size={20} strokeWidth={1.5} />
                </div>
                <div className="flex-1">
                  <h3
                    className="text-lg font-medium text-slate-900 mb-2 group-hover:text-slate-700 transition-colors"
                    style={{ fontFamily: 'Outfit, sans-serif' }}
                  >
                    {service.title}
                  </h3>
                  <p className="text-sm text-slate-500 leading-relaxed">
                    {service.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
